import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col } from 'reactstrap';

/**
 * Renders estimated values header.
 * @param {boolean} isMobile
 * @param {string} vehicleName
 * @param {boolean} showHeaderCaption
 * @param {string} minAppraisalValue
 * @param {string} maxAppraisalValue
 * @returns {ReactElement}
 */
export function EstimatedValuesHeader({
  isMobile,
  vehicleName = '',
  showHeaderCaption = true,
  minAppraisalValue = null,
  maxAppraisalValue = null,
}) {
  const priceCopy =
    minAppraisalValue && maxAppraisalValue
      ? `range from ${minAppraisalValue} - ${maxAppraisalValue}`
      : 'vary significantly by zip code, mileage, and condition';

  return (
    <Row>
      <Col xs={12}>
        <div className="heading-3 mb-0_25">Estimated values for the {vehicleName}</div>
        {showHeaderCaption && (
          <div className="medium text-gray-30">
            Values based on 12,000 miles{isMobile ? <br /> : ' '}driven per year, with no color or options selected.{' '}
            {vehicleName} trade-in prices {priceCopy}. Get a more accurate value for your car with the Edmunds appraisal
            tool.
          </div>
        )}
      </Col>
    </Row>
  );
}

EstimatedValuesHeader.propTypes = {
  isMobile: PropTypes.bool.isRequired,
  vehicleName: PropTypes.string,
  showHeaderCaption: PropTypes.bool,
  minAppraisalValue: PropTypes.string,
  maxAppraisalValue: PropTypes.string,
};
